import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { push } from 'react-router-redux';
import { Formik } from 'formik';

// Components
import ExtComp from '../../components/external';
import NewJobWrapper from '../../components/NewJobWrapper/NewJobWrapper';
// import RadioBtnItem from '../../components/RadioEl/RadioBtnItem';

// Constants
import { maxSmsMsgLength, maxTitleLength, validation } from './constAndValidation';

// Actions
import { setDetails } from '../../reducer/createNewJobActions';

// Style
import s from './NewJobDetails.style';

const NewJobDetails = (props) => {
  const { t, dispatch, specificDetails } = props;
  const formRef = useRef();

  const onConfirm = (values) => {
    dispatch(setDetails(values));
    dispatch(push('/practitioner/new-job/confirm'));
  };

  return (
    <NewJobWrapper
      screenTitle={t('nj_specific_screen_title')}
      percent={75}
      backPath='/practitioner/new-job/select-appointments'
      nextBtnAction={() => {
        const form = formRef.current;
        form.validateForm().then(form.handleSubmit);
      }}
    >
      <Formik
        innerRef={formRef}
        initialValues={specificDetails && specificDetails.hasOwnProperty('sms') ?
          specificDetails
          : {
            waitConfirm: true,
            sms: true, smsTemplate: '', smsMessage: '',
            push: false, pushTemplate: '', pushTitle: '', pushMessage: '',
            email: false
          }}
        validate={validation}
        onSubmit={onConfirm}
      >{(formProps) => {
          const { values, errors, touched, handleChange, handleBlur, setFieldValue } = formProps;

          return (
            <s.DetailsWrapper>
              {/* ──── Waiting type ─────────────────────────────────────────────────────────────────────── */}
              {/* <section className="section">
                <h3 className="section-title">{t('nj_wait_confirm_caption')}</h3>

                <div className="radio-items-wrapper">
                  <RadioBtnItem
                    name="wait-confirm"
                    id="wait-confirm-1"
                    rightLabel={t('nj_wait_confirm_option_1')}
                    checked={values.waitConfirm}
                    onChange={() => { setFieldValue('waitConfirm', true); }}
                  />
                  <RadioBtnItem
                    name="wait-confirm"
                    id="wait-confirm-2"
                    rightLabel={t('nj_wait_confirm_option_2')}
                    checked={!values.waitConfirm}
                    onChange={() => { setFieldValue('waitConfirm', false); }}
                  />
                </div>
              </section> */}

              {/* ──── Checked types ─────────────────────────────────────────────────────────── */}
              <section className="section">
                <h3 className="section-title">{t('nj_mass_message_types_label')}</h3>

                <div className="message-types-row">
                  <ExtComp.CheckBoxField
                    rightLabel={t('nj_mass_message_type_sms')}
                    input={{
                      checked: values.sms,
                      name: 'sms',
                      value: values.sms,
                      onBlur: handleBlur,
                      onChange: handleChange
                    }} />

                  <ExtComp.CheckBoxField
                    rightLabel={t('nj_mass_message_type_push')}
                    input={{
                      checked: values.push,
                      name: 'push',
                      value: values.push,
                      onBlur: handleBlur,
                      onChange: handleChange
                    }} />

                  <ExtComp.CheckBoxField
                    rightLabel={t('nj_mass_message_type_email')}
                    input={{
                      disabled: true,
                      name: 'email',
                      value: values.email,
                      onBlur: handleBlur,
                      onChange: handleChange
                    }} />
                </div>
              </section>

              <div className="positioner-wrapper">
                {/* ──── SMS ─────────────────────────────────────────────────────────────────────────────── */}
                <section className={`section ${values.sms ? 'expanded' : 'collapsed'} ${values.push ? 'show-border-bottom' : ''}`}>
                  <h3 className="section-title">{t('nj_mass_message_sms_caption')}</h3>

                  <div className="input-el-row">
                    <ExtComp.InputTextArea
                      isRequired
                      label={t('nj_mass_message_sms_text')}
                      meta={{ touched: touched.smsMessage, error: errors.smsMessage }}
                      input={{
                        name: 'smsMessage',
                        value: values.smsMessage,
                        onBlur: handleBlur,
                        onChange: handleChange
                      }}
                    />
                    <p className={`chart-counter ${values.smsMessage && values.smsMessage.length > maxSmsMsgLength ? 'error' : ''}`}>
                      {values.smsMessage && values.smsMessage.length || 0}/{maxSmsMsgLength}
                    </p>
                  </div>

                  {/* <ExtComp.InformBlock>
                    Please note that 1 SMS contains 160 characters, if your message contains more characters, several SMS will be sent
                  </ExtComp.InformBlock> */}

                </section>

                {/* ──── Push  ─────────────────────────────────────────────────────────── */}
                <section className={`section ${values.push ? 'expanded' : 'collapsed'}`}>
                  <h3 className="section-title">{t('nj_mass_message_push_caption')}</h3>

                  <div className="input-el-row">
                    <ExtComp.InputField
                      isRequired={false}
                      max={maxTitleLength}
                      label={t('nj_mass_message_push_title')}
                      meta={{ touched: touched.pushTitle, error: errors.pushTitle }}
                      input={{
                        name: 'pushTitle',
                        value: values.pushTitle,
                        onChange: handleChange,
                        onBlur: handleBlur,
                      }} />
                  </div>

                  <div className="input-el-row">
                    <ExtComp.InputTextArea
                      isRequired
                      label={t('nj_mass_message_push_message')}
                      meta={{ touched: touched.pushMessage, error: errors.pushMessage }}
                      input={{
                        name: 'pushMessage',
                        value: values.pushMessage,
                        onChange: handleChange,
                        onBlur: handleBlur,
                      }}
                    />
                  </div>
                </section>

                {/* ──── Empty selection ───────────────────────────────────────────────────────────────── */}
                <section className={`empty-warning ${!values.sms && !values.push ? 'show' : ''}`} >
                  <h1>{t('nj_mass_message_empty_types')}</h1>
                </section>
              </div>

            </s.DetailsWrapper>);
        }
        }
      </Formik>
    </NewJobWrapper>
  );
};

const mapStateToProps = store => ({
  specificDetails: store.practitioner.createNewJob.specificDetails,
});

export default translate()(
  connect(mapStateToProps)(NewJobDetails)
);
